export default {
  GET_DB_LIST_SUCCESS(state, data) {
    state.dbList = data
    state.errors.dbListError = ''
  },
  GET_DB_LIST_ERROR(state, error) {
    state.errors.dbListError = error
  },
  GET_DB_LIST_LOADING(state, payload) {
    state.loading.dbListLoading = payload
  },
  SET_TYNDYK_PERSONAL_NAME(state, name) {
    state.innInfo.personal = name
  },
  SET_TYNDYK_ORGANISATION_NAME(state, name) {
    state.innInfo.organisation = name
  },
  SET_TYNDYK_PERSONAL_NAME_ERROR(state, error) {
    state.innError.personal = error
  },
  SET_TYNDYK_ORGANISATION_NAME_ERROR(state, error) {
    state.innError.organisation = error
  },
  CREATE_NEW_DB_SUCCESS(state, data) {
    state.newDb = data
    state.errors.newDbError = ''
  },
  CREATE_NEW_DB_ERROR(state, error) {
    state.errors.newDbError = error
  },
  LOADING_SAVE_SCHEMA_BTN(state, data) {
    state.loading.createSchemaBtn = data
  },
  LOADING_NEW_DB_BTN(state, data) {
    state.loading.newDdBtn = data
  },
  GET_SCHEMA_SUCCESS(state, data) {
    state.dbSchema = data
    state.errors.getSchemaError = null
  },
  GET_SCHEMA_ERROR(state, error) {
    state.errors.getSchemaError = error
  },
  LOADING_EDIT_SCHEMA_BTN(state, data) {
    state.loading.editSchemaBtn = data
  },
  DELETE_DB_LOADING(state, payload) {
    state.loading.deleteDbLoading = payload
  },
  DELETE_DB_SUCCESS(state, payload) {
    state.errors.deleteDbError = null
  },
  DELETE_DB_ERROR(state, error) {
    state.errors.deleteDbError = error
  },
  EDIT_DB_NAME_SUCCESS(state, payload) {
    state.editDbNameResponse = payload
    state.errors.editDbNameError = null
  },
  EDIT_DB_NAME_ERROR(state, error) {
    state.errors.editDbNameError = error
  },
  EDIT_DB_NAME_LOADING(state, payload) {
    state.loading.editDbNameLoading = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/dbConstructor/mutations.js